//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet, axiosPost, axiosDelete } from '../../axios/axios.js'
import AddRoadsMskLabelsDialog from '../Request/RequestAddRoadsLabels.vue'
import ReportRoadsFiles from './ReportRoadsFiles.vue'
import ReportRoadsImages from './ReportRoadsImages.vue'
import { prepareFilesDataToUpload, getUploadResult, convertTime } from '../../components/helpers.js'
import Report from '../Report/Report.vue'
import { convertReportFromServer } from '../Report/Report.js'
import ReportRoadsImagesSelectionDialog from './ReportRoadsImagesSelectionDialog.vue'
import ObjectCardWrapper from '../../components/Card/ObjectCardWrapper.vue'
import { EventBus } from '../../EventBus/EventBus.js'
import { closeRequest } from '../Task/TaskActionsCloseRequest.js'

export default {
  components: {
    AddRoadsMskLabelsDialog,
    ReportRoadsFiles,
    ReportRoadsImages,
    Report,
    ObjectCardWrapper,
    ReportRoadsImagesSelectionDialog
  },
  mixins: [closeRequest],
  props: {
    requestId: {
      type: Number,
      default: null
    },
    reportRoadsTitle: {
      type: String,
      default: ''
    },
    reportRoads: {
      type: Object,
      default () {
        return {}
      }
    },
    bpContextId: {
      type: Number,
      default: null
    },
    stateName: {
      type: String,
      default: ''
    }
  },
  data: function () {
    return {
      visName: 'Roads',
      requestAddRoadsMskLabelsDialogOpened: false,

      faultTypesInRoadsMsk: [],
      typicalCommentsInRoadsMsk: [],
      equipmentStatesInRoadsMsk: [],

      taskStatus: null,
      selectedRoadsMskLabels: [],
      serviceObjectType: null,
      serviceObjectTypeId: null,
      serviceObjectKey: null,
      serviceObjectId: null,

      imagesFromRequest: [],
      imagesFromRequestSmall: [],
      reportsDocuments: [],

      reportRoadsImages: [],
      reportRoadsImagesSmall: [],
      reportRoadsFiles: [],

      requestRoads: null,

      filteredTypicalCommentsInRoadsMsk: [],

      confirmCloseRequest: false,
      loading: false,
      filesToUpload: [],
      imagesToUpload: [],
      displayReportOnSide: false,
      selectedReportId: null,
      selectedReportIndex: null,

      selectedTab: 'reports',
      imagesSelectionDialogOpened: false,

      selectedTypicalComment: null,

      reportsHistoryLoaded: false
    }
  },
  computed: {
    finishComment: {
      get: function () {
        return this.reportRoads.finishComment
      },
      set: function (value) {
        this.reportRoads.finishComment = value.replaceAll('\f', '-')
      }
    },
    activeReportsDocuments: function () {
      return this.reportsDocuments.filter(report => !report.fromHistory)
    },
    selectedRoadsMskLabelsKeys: function () {
      return this.selectedRoadsMskLabels.map(label => label.key)
    },
    roadsLabelsKeysFromTypicalComments: function () {
      const keys = []
      for (const comment of this.typicalCommentsInRoadsMsk) {
        if (!comment.roadsLabels || !comment.roadsLabels.length) {
          continue
        }
        for (const label of comment.roadsLabels) {
          if (label && label.key != null && !keys.includes(label.key)) {
            keys.push(label.key)
          }
        }
      }
      return keys
    }
    // По правильному для такой реализации нужно сохранять выбранный типовой комментарий. Пока не будем это делать и просто отображаем результат выполнения запроса.
    // matchingTypicalCommentByFinishComment: function () {
    //   const commentText = this.reportRoads && this.reportRoads.finishComment
    //   if (!commentText || !this.typicalCommentsInRoadsMsk.length) {
    //     return null
    //   }
    //   return this.typicalCommentsInRoadsMsk.find(comment => comment.name === commentText) || null
    // },
    // missingRoadsLabelsFromTypicalComment: function () {
    //   const typicalComment = this.matchingTypicalCommentByFinishComment
    //   if (!typicalComment || !typicalComment.roadsLabels || !typicalComment.roadsLabels.length) {
    //     return []
    //   }
    //   return typicalComment.roadsLabels.filter(label =>
    //     label && label.key != null && !this.selectedRoadsMskLabelsKeys.includes(label.key)
    //   )
    // }
  },
  watch: {
    selectedTypicalComment: function (result) {
      this.reportRoads.finishComment = result ? result.name : ''
      if (result && result.roadsLabels && result.roadsLabels.length) {
        this.addRoadsLabelsFromTypicalComment(result.roadsLabels)
      }
    },
    selectedReportId: function () {
      for (const reportDocumentsIndex in this.reportsDocuments) {
        if (this.reportsDocuments[reportDocumentsIndex].id === this.selectedReportId) {
          this.selectedReportIndex = reportDocumentsIndex
          break
        }
      }
    },
    displayReportOnSide: function (result) {
      if (result && this.selectedReportId === null && this.reportsDocuments && this.activeReportsDocuments.length >= 1) {
        this.selectedReportId = this.activeReportsDocuments[this.activeReportsDocuments.length - 1].id
      }
    }
  },
  created: function () {
    this.loading = true
    this.loadTaskDocumentsList(this.requestId)
      .then((taskDocuments) => this.loadAndPrepareDataFromDocuments(taskDocuments))
      .then(() => this.prepareReportRoadsFilesAndImages())
      .then(() => this.loadFaultTypesInRoadsMsk(this.serviceObjectType))
      .then(() => this.loadEquipmentStatesInRoadsMsk())
      .then(() => this.loadTypicalCommentsInRoadsMsk(this.serviceObjectTypeId))
      .then(() => this.loadDefaultRoadsMskDefaultSelectedValues(this.serviceObjectType))
      .finally(() => {
        this.onShowReportsAndServiceObject()
        this.loading = false
      })
    EventBus.$on('reports-history-load', this.loadAndPrepareReportsFromHistory)
  },
  beforeDestroy: function () {
    EventBus.$off('reports-history-load', this.loadAndPrepareReportsFromHistory)
  },
  methods: {
    convertTime: convertTime,
    onSelectImagesFromReports: function () {
      this.imagesSelectionDialogOpened = true
    },
    onConfirmImagesSelection: function (selectedImages) {
      this.reportRoadsImages = selectedImages
      this.imagesSelectionDialogOpened = false
    },
    setFinishComment: function (value) {
      if (value !== null) {
        this.reportRoads.finishComment = value
      } else {
        this.reportRoads.finishComment = ''
      }
    },
    onShowReportsAndServiceObject: function () {
      if (this.activeReportsDocuments.length === 0) {
        this.selectedTab = 'serviceObject'
      }

      this.displayReportOnSide = true
      const comment = this.reportRoads.finishComment
      this.reportRoads.finishComment = null

      this.$nextTick(() => {
        this.reportRoads.finishComment = comment
      })
    },
    onSelectedFilesChanged: function (files) {
      this.reportRoadsFiles = files
    },
    onFilesToUploadChanged: function (files) {
      this.filesToUpload = files
    },
    onImagesSelectionChanged: function (images) {
      this.reportRoadsImages = images
    },
    onImagesToUploadChanged: function (files) {
      this.imagesToUpload = files
    },
    typicalCommentsFilter (value, update) {
      if (value === '') {
        update(() => {
          this.filteredTypicalCommentsInRoadsMsk = this.typicalCommentsInRoadsMsk
        })
        return
      }

      update(() => {
        const needle = value.toLowerCase()
        this.filteredTypicalCommentsInRoadsMsk = this.typicalCommentsInRoadsMsk
          .filter(v => v.name.toLowerCase().indexOf(needle) > -1)
      })
    },
    isImage: function (str) {
      return str !== null && str.startsWith('image/')
    },
    onConfirmAddRoadsMskLabels: function (roadsLabels) {
      this.selectedRoadsMskLabels = roadsLabels
      this.requestAddRoadsMskLabelsDialogOpened = false
    },
    canRemoveRoadsMskLabel: function (label) {
      return !this.reportRoads.transmitted &&
        !this.reportRoads.transmittedByEmail &&
        label &&
        this.roadsLabelsKeysFromTypicalComments.includes(label.key)
    },
    onRemoveRoadsMskLabel: function (label) {
      if (!this.canRemoveRoadsMskLabel(label)) {
        return
      }

      const labelsToSet = this.selectedRoadsMskLabels.filter(item => item.key !== label.key)
      const bodyFormData = new FormData()
      bodyFormData.set('id', this.requestId)
      bodyFormData.set('labels', labelsToSet.map(item => item.key).join(', '))

      axiosPost({
        url: '/service/delta/request/setUserRoadsLabels',
        data: bodyFormData,
        onSuccess: () => {
          this.selectedRoadsMskLabels = labelsToSet
          this.$q.notify({
            type: 'positive',
            message: 'Метка Roads удалена: ' + label.name,
            progress: true,
            timeout: 3000
          })
        },
        onFailure: (error) => {
          this.$q.notify({
            type: 'negative',
            message: (error && error.message) ||
              ('Не удалось удалить метку Roads: ' + label.name),
            progress: true,
            timeout: 8000
          })
        }
      })
    },
    addRoadsLabelsFromTypicalComment: function (roadsLabels = []) {
      const newLabels = roadsLabels.filter(label =>
        label && label.key != null && !this.selectedRoadsMskLabelsKeys.includes(label.key)
      )

      if (!newLabels.length) {
        return
      }

      const newKeys = newLabels.map(label => label.key)
      const labelsKeysToSet = [...this.selectedRoadsMskLabelsKeys, ...newKeys]
      const labelsNames = newLabels.map(label => label.name).join(', ')
      const bodyFormData = new FormData()
      bodyFormData.set('id', this.requestId)
      bodyFormData.set('labels', labelsKeysToSet.join(', '))

      axiosPost({
        url: '/service/delta/request/setUserRoadsLabels',
        data: bodyFormData,
        onSuccess: () => {
          this.selectedRoadsMskLabels = [...this.selectedRoadsMskLabels, ...newLabels]
          this.$q.notify({
            type: 'positive',
            message: 'Метки Roads успешно добавлены: ' + labelsNames,
            progress: true,
            timeout: 3000
          })
        },
        onFailure: (error) => {
          this.$q.notify({
            type: 'negative',
            message: (error && error.message) ||
              ('Не удалось добавить метки Roads из типового комментария: ' + labelsNames),
            progress: true,
            timeout: 8000
          })
        }
      })
    },
    prepareReportRoadsFilesAndImages: function () {
      if (this.reportRoads.finishDocuments && this.reportRoads.finishDocuments.length) {
        for (const reportRoadsDocument of this.reportRoads.finishDocuments) {
          if (this.isImage(reportRoadsDocument.contentType) && reportRoadsDocument.category !== 'files') {
            this.reportRoadsImagesSmall.push({
              id: reportRoadsDocument.id,
              url: '/service/delta/document/thumbnail/' + reportRoadsDocument.id + '/140/140',
              category: reportRoadsDocument.category
            })

            const imageName = this.reportRoadsTitle +
                              '-Выбранные-' +
                              (this.reportRoadsImages.length + 1) +
                              '.' +
                              reportRoadsDocument.contentType.split('/')[1]

            this.reportRoadsImages.push({
              id: reportRoadsDocument.id,
              url: '/service/fileobj/read/' + reportRoadsDocument.id,
              name: imageName,
              category: reportRoadsDocument.category,
              description: reportRoadsDocument.user ? [{ name: 'Добавил в отчёт', value: reportRoadsDocument.user }] : null
            })
          } else {
            reportRoadsDocument.url = '/service/fileobj/read/' + reportRoadsDocument.id
            this.reportRoadsFiles.push(reportRoadsDocument)
          }
        }
      }

      return Promise.resolve()
    },
    loadAndPrepareReportsFromHistory: async function () {
      const urlParams = new URLSearchParams()

      if (this.serviceObjectType) {
        urlParams.append('type', this.serviceObjectType)
      }

      urlParams.append('limit', 10000)

      urlParams.append('external', false)

      // if (this.searchText) {
      //   urlParams.append('pattern', this.searchText)
      //   urlParams.append('patternParams', this.searchFieldKeys.toString())
      // }

      if (!this.reportsHistoryLoaded) {
        return axiosGet({
          url: '/service/delta/serviceobject/reportsHistory/' + this.serviceObjectId + '?' + urlParams.toString(),
          onSuccess: (response) => {
            const reportsRaw = response.data.result.reports
            reportsRaw.forEach(reportRaw => {
              this.prepareDataFromReport(reportRaw, true)
            })
            this.reportsHistoryLoaded = true
          },
          onFailure: 'Ошибка получения истории отчётов по объекту обслуживания'
        }).finally(() => {
          EventBus.$emit('reports-history-load-end')
        })
      } else {
        EventBus.$emit('reports-history-load-end')
      }
    },
    loadAndPrepareDataFromDocuments: async function (taskDocuments) {
      const promises = []

      for (const taskDocument of taskDocuments) {
        if (taskDocument.type === 'request') {
          promises.push(this.loadAndPrepareDataFromRequest(taskDocument))
        } else if (taskDocument.type === 'requestReport') {
          promises.push(await this.loadAndPrepareDataFromReport(taskDocument))
        }
      }

      return Promise.all(promises)
    },
    loadAndPrepareDataFromRequest: function (request) {
      return axiosGet({
        url: '/service/delta/request/getRequest?id=' + request.id,
        onSuccess: (response) => {
          this.prepareDataFromRequest(response.data.result)
        },
        onFailure: 'Ошибка загрузки данных из заявки.',
        msgTarget: this
      })
    },
    prepareDataFromRequest: function (request) {
      this.taskStatus = request.bpStateId
      this.selectedRoadsMskLabels = request.roadsLabels || []

      if (request && request.serviceObject && request.serviceObject.type) {
        this.serviceObjectType = request.serviceObject.type.key
        this.serviceObjectTypeId = request.serviceObject.type.id
        this.serviceObjectKey = Number(request.serviceObject.key)
        this.serviceObjectId = request.serviceObject.id
      } else {
        this.serviceObjectType = null
        this.serviceObjectTypeId = null
        this.serviceObjectKey = null
        this.serviceObjectId = null
      }

      if (!request.documents) {
        return
      }

      for (const requestDocument of request.documents) {
        if (this.isImage(requestDocument.contentType) && requestDocument.category !== 'files') {
          this.imagesFromRequestSmall.push(
            '/service/delta/document/thumbnail/' + requestDocument.id + '/190/190'
          )

          const imageName = this.reportRoadsTitle +
                                '-Из заявки-' +
                                (this.imagesFromRequest.length + 1) +
                                '.' +
                                requestDocument.contentType.split('/')[1]

          this.imagesFromRequest.push({
            id: requestDocument.id,
            url: '/service/fileobj/read/' + requestDocument.id,
            name: imageName
          })
        }
      }

      this.requestRoads = request.roadsRequestData || {}
    },
    loadAndPrepareDataFromReport: function (report) {
      return axiosGet({
        url: '/service/delta/report/' + report.id,
        onSuccess: (response) => {
          this.prepareDataFromReport(response.data.result)
        },
        onFailure: 'Ошибка загрузки документов по отчёту.',
        msgTarget: this
      })
    },
    prepareDataFromReport: function (report, fromHistory = false) {
      if (!report.documents) {
        return
      }

      report = convertReportFromServer(report, this.$store.getters.getUser)

      const reportImages = []
      const reportImagesSmall = []
      const reportFiles = []

      for (const reportDocument of report.documents) {
        if (this.isImage(reportDocument.contentType) && reportDocument.category !== 'dispatcher') {
          const imageName = this.reportRoadsTitle + // FIX
                            '-Из отчёта-' +
                            (reportImages.length + 1) +
                            '.' +
                            reportDocument.contentType.split('/')[1]

          reportImages.push({
            id: reportDocument.id,
            url: '/service/fileobj/read/' + reportDocument.id,
            name: imageName,
            category: reportDocument.category
          })

          reportImagesSmall.push({
            id: reportDocument.id,
            url: '/service/delta/document/thumbnail/' + reportDocument.id + '/140/140',
            category: reportDocument.category
          })
        } else {
          if (reportDocument.category !== 'dispatcher') {
            const documentUrl = '/service/delta/document/read' +
                                '?id=' + reportDocument.id +
                                (reportDocument.relId ? '&relId=' + reportDocument.relId : '')

            reportFiles.push({
              id: reportDocument.id,
              url: documentUrl,
              name: reportDocument.name,
              category: reportDocument.category,
              size: reportDocument.size
            })
          }
        }
      }

      this.reportsDocuments.push({
        id: report.id,
        name: report.name,
        report: report,
        reportImages: reportImages,
        reportImagesSmall: reportImagesSmall,
        reportFiles: reportFiles,
        fromHistory: fromHistory
      })
    },
    loadTaskDocumentsList: function (requestId) {
      return axiosGet({
        url: '/service/delta/request/documents?id=' + requestId,
        onSuccess: (response) => {
          return Promise.resolve(response.data.result.documents)
        },
        onFailure: 'Ошибка загрузки документов по заданию.',
        msgTarget: this
      })
    },
    loadDefaultRoadsMskDefaultSelectedValues: function (serviceObjectType = null) {
      return axiosGet({
        url: '/service/settings/map?prefix=requestFinishReport.' + serviceObjectType + '.',
        onSuccess: (response) => {
          if (response.data.equipmentStatusRoads && !this.reportRoads.finishEquipmentStatusRoads) {
            this.reportRoads.finishEquipmentStatusRoads = response.data.equipmentStatusRoads.id
          }

          if (response.data.breakageRoads && !this.reportRoads.finishBreakageRoads) {
            this.reportRoads.finishBreakageRoads = response.data.breakageRoads.id
          }
        },
        onFailure: 'Ошибка загрузки значений по умолчанию',
        msgTarget: this
      })
    },
    loadFaultTypesInRoadsMsk: function (serviceObjectType = null) {
      const urlParameters = [
        {
          param: 'roadsId',
          type: 'integer',
          action: 'any'
        },
        {
          param: 'serviceObjectType',
          type: 'object',
          action: 'any'
        }
      ]

      const encodedUrlParameters = encodeURI(JSON.stringify(urlParameters))
      const url = '/service/obj/search' +
                  '?params=' + encodedUrlParameters +
                  '&nameField=name' +
                  '&paramsOperation=and' +
                  '&type=breakageRoads' +
                  '&limit=100000'

      return axiosGet({
        url: url,
        onSuccess: (response) => {
          this.faultTypesInRoadsMsk = []

          if (!response.data.result) {
            return
          }

          for (const faultType of response.data.result) {
            if (faultType['param.serviceObjectType']) {
              for (let i = 0; i < faultType['param.serviceObjectType'].length; i++) {
                if (serviceObjectType !== null) {
                  if (faultType['param.serviceObjectType'][i].key === serviceObjectType) {
                    this.faultTypesInRoadsMsk.push(faultType)
                  }
                } else {
                  faultType.name = faultType.name +
                                   ' (' +
                                   faultType['param.serviceObjectType'][i].name +
                                   ')'

                  this.faultTypesInRoadsMsk.push(faultType)
                }
              }
            }
          }
        },
        onFailure: 'Ошибка загрузки типов неисправностей в Roads',
        msgTarget: this
      })
    },
    loadTypicalCommentsInRoadsMsk: function (typeId = null) {
      const url = '/service/delta/roadsRequest/ref/getDefaultClosingCommentsRoads' +
                  (typeId != null ? '?typeId=' + typeId : '')

      return axiosGet({
        url: url,
        onSuccess: (response) => {
          this.typicalCommentsInRoadsMsk = response.data.result || []
        },
        onFailure: 'Ошибка загрузки типовых комментариев в Roads',
        msgTarget: this
      })
    },
    loadEquipmentStatesInRoadsMsk: function () {
      return axiosGet({
        url: '/service/delta/roadsRequest/ref/getEquipmentRoadsStatuses',
        onSuccess: (response) => {
          this.equipmentStatesInRoadsMsk = response.data.result
        },
        onFailure: 'Ошибка загрузки состояний оборудования после выполнения работ',
        msgTarget: this
      })
    },
    onSaveDocument: async function () {
      try {
        this.loading = true
        await this.saveDocument(true)
        this.loading = false
      } catch (e) {
        this.loading = false
      }

      this.$emit('report-updated')
    },
    saveDocument: async function (throws = false) {
      this.reportRoads.finishDocuments = []

      this.reportRoadsImages.forEach((image) => {
        this.reportRoads
          .finishDocuments
          .push({
            id: +image.url.slice('/service/fileobj/read/'.length)
          })
      })

      this.reportRoadsFiles.forEach((file) => {
        this.reportRoads
          .finishDocuments
          .push({
            id: file.id,
            category: 'files'
          })
      })

      const bodyFormData = new FormData()
      bodyFormData.set('reportId', this.reportRoads.id)
      const reportRoadsStr = JSON.stringify(this.reportRoads)
      bodyFormData.set('properties', reportRoadsStr)

      await axiosPost({
        url: '/service/delta/finishreport/edit',
        data: bodyFormData,
        config: { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } },
        onFailure: 'Ошибка сохранения отчёта для Roads',
        msgTarget: this,
        throws: throws
      })

      await this.uploadFiles(this.imagesToUpload, 'documents', throws)
      await this.uploadFiles(this.filesToUpload, 'files', throws)
    },
    uploadFiles: async function (files, categoryKey, throws = false) {
      try {
        const uploadConfig = {
          objectId: this.reportRoads.id,
          files: files,
          categoryKey: categoryKey, // TODO
          url: '/service/delta/finishreport/uploadFinishDocument',
          documentType: null,
          property: null
        }
        const filesData = prepareFilesDataToUpload(uploadConfig)
        return await getUploadResult(filesData, true, this)
      } catch (error) {
        if (throws) {
          throw new Error(error.message)
        }
      }
    },
    onCloseRequestInRoadsMsk: async function (sendEmail = false) {
      let errorOnSaveDocument = false

      if (!sendEmail || !this.reportRoads.transmittedByEmail) {
        try {
          this.loading = true
          await this.saveDocument(true)
          this.loading = false
        } catch (e) {
          this.loading = false
          errorOnSaveDocument = true
        }

        if (errorOnSaveDocument) {
          return
        }
      }

      const closeRequestInRoadsMsk = (resend) => {
        const data = {
          finishReportId: this.reportRoads.id
        }
        if (resend) {
          data.resend = resend
        }

        this.loading = true

        axiosPost({
          url: url,
          data: data,
          config: { headers: { 'Content-Type': 'application/json' } },
          onSuccess: (response) => {
            this.$q.notify({
              type: 'positive',
              message: successMessage,
              progress: true,
              timeout: 3000
            })

            if (sendEmail) {
              this.$emit('report-updated')
            } else {
              this.confirmCloseRequest = true
            }
          },
          onFailure: errorMessage,
          msgTarget: this
        }).finally(() => {
          this.loading = false
        })
      }

      let url, successMessage, errorMessage

      if (sendEmail) {
        url = '/vis/sendEmailToCloseRequestRoads/onetouch'
        successMessage = 'Письмо для закрытия заявки в ' + this.visName + ' успешно отправлено'
        errorMessage = 'Ошибка отправки письма для закрытия заявки в ' + this.visName

        if (this.reportRoads.transmittedByEmail) {
          this.$d_ask({
            callback: () => {
              closeRequestInRoadsMsk(true)
            },
            header: 'Письмо для закрытия уже отправлено. Хотите отправить повторно?'
          })
        } else {
          closeRequestInRoadsMsk()
        }
      } else {
        url = '/vis/closeRequestRoads/onetouch'
        successMessage = 'Заявка в ' + this.visName + ' успешно закрыта'
        errorMessage = 'Ошибка закрытия заявки в ' + this.visName
        closeRequestInRoadsMsk()
      }
    },
    onCloseRequest: function () {
      const props = {}
      if (this.taskStatus === 'BS4') {
        props.reportDeletionConfirmed = true
      }

      this.loading = true
      this.closeRequest(this.bpContextId, props)
        .finally(() => {
          this.$emit('report-updated')
          this.loading = false
        })
    },
    onRemove: function () {
      this.loading = true
      axiosDelete({
        url: '/service/delta/finishreport/remove/' + this.reportRoads.id,
        onSuccess: () => {
          this.$q.notify({
            type: 'positive',
            message: 'Отчёт удалён',
            progress: true,
            timeout: 3000
          })

          this.$emit('report-updated')
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message,
            progress: true,
            timeout: 8000
          })

          this.$emit('report-updated')
        }
      }).finally(() => {
        this.loading = false
      })
    },
    onNotCloseRequest: function () {
      this.confirmCloseRequest = false
      this.$emit('report-updated')
    },
    onCreateRequestInRoadsMsk: async function () {
      let errorOnSaveDocument = false

      try {
        this.loading = true
        await this.saveDocument(true)
        this.loading = false
      } catch (e) {
        this.loading = false
        errorOnSaveDocument = true
      }

      if (errorOnSaveDocument) {
        return
      }

      const data = { requestId: this.requestId }
      this.loading = true

      axiosPost({
        url: '/vis/createRequestRoads/onetouch',
        data: data,
        config: { headers: { 'Content-Type': 'application/json' } },
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: 'Заявка в ' + this.visName + ' успешно создана',
            progress: true,
            timeout: 3000
          })

          this.$emit('report-updated')
        },
        onFailure: 'Ошибка создания заявки в ' + this.visName,
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    },
    onSelectServiceObjectFiles: function () {
      this.selectedTab = 'serviceObject'
      this.$nextTick(() => {
        this.$refs.serviceObjectCardWrapper.getCard()
          .then(card => card.showDocumentationTab())
          // .then(tab => {
          //   const files = tab.getSelectedFiles()
          //   console.log(files)
          // })
      })
    },
    onServiceObjectFilesSelected: function (files) {
      files.map(fileWrapper => {
        return {
          id: fileWrapper.id,
          name: fileWrapper.name,
          url: fileWrapper.url
        }
      }).forEach(fileData => {
        if (!this.reportRoadsFiles.find(o => o.id === fileData.id)) {
          this.reportRoadsFiles.push(fileData)
        }
      })
    }
  }
}

